import React from 'react';
import { Modal, Paper } from '@mui/material';
import EditManufacturerLayout from '../layouts/EditManufacturerLayout';
import {Manufacturer} from "../../../classes/Manufacturer";

function UpdateManufacturerModal(props: {
    isOpen: boolean,
    selectedManufacturerObject: Manufacturer,
    onSubmit: Function,
    onClose: Function,
}) {
    return (
        <Modal
            open={props.isOpen}
            onClose={() => props.onClose()}
        >
            <Paper
                sx={{
                    position: 'absolute',
                    width: '600px',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    padding: 2
                }}
            >
                <EditManufacturerLayout
                    title="Update Manufacturer"
                    initInfo={props.selectedManufacturerObject}
                    onCancel={() => props.onClose()}
                    onSubmit={props.onSubmit}
                />
            </Paper>
        </Modal>
    );
}

export default UpdateManufacturerModal;